import { Link } from 'react-router-dom';
import type { Media } from '@/types/media';
import { TYPE_LABELS } from '@/types/media';
import MediaCard from '@/components/base/MediaCard';

interface LatestAndHotProps {
  latest: Media[];
  hot: Media[];
}

export default function LatestAndHot({ latest, hot }: LatestAndHotProps) {
  return (
    <section className="w-full px-4 md:px-8 mt-10 md:mt-14">
      <div className="grid grid-cols-1 lg:grid-cols-4 gap-6 md:gap-8">
        <div className="lg:col-span-3">
          <div className="flex items-end justify-between mb-5">
            <div>
              <h2 className="text-xl md:text-2xl font-bold text-foreground-950">最新更新</h2>
              <p className="mt-1 text-sm text-foreground-500">近期上线的影视内容，持续同步中</p>
            </div>
            <Link
              to="/category/movie"
              className="hidden sm:inline-flex items-center gap-1 text-sm font-medium text-primary-700 hover:text-primary-600 cursor-pointer whitespace-nowrap"
            >
              查看全部
              <i className="ri-arrow-right-line"></i>
            </Link>
          </div>
          <div className="grid grid-cols-2 md:grid-cols-3 gap-3 md:gap-5">
            {latest.map((item) => (
              <MediaCard key={item.id} media={item} />
            ))}
          </div>
        </div>

        <aside className="lg:col-span-1">
          <div className="rounded-lg bg-background-50 border border-background-200/80 p-4 md:p-5">
            <div className="flex items-center gap-2 mb-4">
              <span className="w-8 h-8 flex items-center justify-center rounded-md bg-accent-100 text-accent-600">
                <i className="ri-fire-line"></i>
              </span>
              <h2 className="text-base md:text-lg font-bold text-foreground-950">热门推荐</h2>
            </div>
            <ul className="flex flex-col divide-y divide-background-200">
              {hot.map((item, rankIndex) => (
                <li key={item.id}>
                  <Link to={`/detail/${item.id}`} className="group flex gap-3 py-3 cursor-pointer">
                    <span
                      className={`shrink-0 w-6 h-6 flex items-center justify-center rounded text-xs font-bold ${
                        rankIndex < 3
                          ? 'bg-accent-500 text-background-50'
                          : 'bg-background-200 text-foreground-600'
                      }`}
                    >
                      {rankIndex + 1}
                    </span>
                    <div className="min-w-0 flex-1">
                      <p className="text-sm font-medium text-foreground-900 group-hover:text-primary-700 line-clamp-1 transition-colors">
                        {item.title}
                      </p>
                      <p className="mt-0.5 text-xs text-foreground-500">
                        {TYPE_LABELS[item.type]} · {item.region} · {item.year}
                      </p>
                    </div>
                    <span className="shrink-0 text-xs font-semibold text-accent-600 self-center">
                      {item.rating}
                    </span>
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </aside>
      </div>
    </section>
  );
}